import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { Bleedable } from '@fs/zion-ui'
import { useLocation } from '@fs/zion-router'
import useIsMobile from '../useIsMobile'
import IsNavDrawerHiddenContext from '../IsNavDrawerHiddenContext'

const viewWrapCss = css`
  /* min-width of 0 needed to prevent the view wrapper from blowing out of its parent grid */
  min-width: 0;
`

/** Used around each of the different reservation list views:
 * - My Reservations
 * - Family Groups
 * - Shared With Temple
 * - Completed
 * - Ordinances Ready
 */

export default function ViewWrapper({ children }) {
  const isNavDrawerHidden = useContext(IsNavDrawerHiddenContext)
  const isMobile = useIsMobile()
  const isLargeMobile = isNavDrawerHidden && isMobile
  const { pathname } = useLocation()
  const isAppointment = pathname === '/appointment'

  return (
    <Bleedable
      sides={isLargeMobile || isAppointment ? 0 : 24}
      top={isAppointment ? 0 : 12}
      bottom={isAppointment ? 0 : 16}
      css={viewWrapCss}
    >
      {children}
    </Bleedable>
  )
}
